// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NativeSelect_wrapper__3_7nH","select":"NativeSelect_select__hMd3D","placeholder":"NativeSelect_placeholder__2ZiQQ","icon":"NativeSelect_icon__1xvCE"};